import { Component } from '@angular/core';
import { NavController, Platform, LoadingController } from '@ionic/angular';
// import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  public menuItems = [];

  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home-outline'
    },
    {
      title: 'Access Services',
      url: '/access-services',
      icon: 'lock-open-outline'
    },
    {
      title: 'Role Access',
      url: '/rol',
      icon: 'lock-closed-outline',
    },
    {
      title: 'User Role',
      url: '/user-rol',
      icon: 'accessibility-outline'
    },
    {
      title: 'Assign Tasks',
      url: '/assing-tasks',
      icon: 'speedometer-outline'
    },
    {
      title: 'Reports',
      url: '/reports',
      icon: 'analytics-outline'
    },
    {
      title: 'Customer List',
      url: '/customers',
      icon: 'people-outline'
    },
    {
      title: 'New Customer',
      url: '/new-customer',
      icon: 'people-outline'
    },
    {
      title: 'Employee List',
      url: '/employees',
      icon: 'man-outline'
    },
    {
      title: 'New Employee',
      url: '/new-employee',
      icon: 'man-outline'
    },
    {
      title: 'Department List',
      url: '/employee-department',
      icon: 'layers-outline'
    },
    {
      title: 'New Department',
      url: '/new-employee-department',
      icon: 'layers-outline'
    },
    {
      title: 'Company List',
      url: '/companies',
      icon: 'business-outline'
    },
    {
      title: 'New Company',
      url: '/new-companie',
      icon: 'business-outline',
    },
    {
      title: 'Contact List',
      url: '/association-contact-list',
      icon: 'grid-outline'
    },
    {
      title: 'New Contact',
      url: '/new-section',
      icon: 'grid-outline'
    },
    {
      title: 'Template List',
      url: '/template-list',
      icon: 'document-attach-outline'
    },
    {
      title: 'New Template',
      url: '/new-template',
      icon: 'document-attach-outline'
    },
    {
      title: 'Template Form List',
      url: '/template-form-list',
      icon: 'document-attach-outline'
    },
    {
      title: 'New Template Form',
      url: '/template-form',
      icon: 'document-attach-outline'
    },
    {
      title: 'Projects List',
      url: '/project',
      icon: 'clipboard-outline'
    },
    {
      title: 'New Project',
      url: '/new-project',
      icon: 'clipboard-outline'
    },
    {
      title: 'Proposal List',
      url: '/proposal-list',
      icon: 'checkbox-outline'
    },
    {
      title: 'Documents List',
      url: '/document-list',
      icon: 'images-outline'
    },
    {
      title: 'New Document',
      url: '/new-document',
      icon: 'images-outline'
    },
    {
      title: 'Documents Category List',
      url: '/documents-category',
      icon: 'list-outline'
    },
    {
      title: 'Document Category',
      url: '/new-document-category',
      icon: 'list-outline'
    },
    {
      title: 'Materials List',
      url: '/materials',
      icon: 'construct-outline'
    },
    {
      title: 'New Material',
      url: '/new-material',
      icon: 'construct-outline'
    },
    {
      title: 'Type Materials List',
      url: '/type-material',
      icon: 'build-outline'
    },
    {
      title: 'New Type Material',
      url: '/new-type-material',
      icon: 'build-outline'
    },
    {
      title: 'Customer Claim List',
      url: '/client-claime-list',
      icon: 'information-circle-outline'
    },
    {
      title: 'Customer Claim',
      url: '/client-claime',
      icon: 'information-circle-outline'
    },
    {
      title: 'Customer Materials List',
      url: '/customers-select-materials-list',
      icon: 'checkmark-circle-outline'
    },
    {
      title: 'Customer Send Materials',
      url: '/customer-select-materials',
      icon: 'checkmark-circle-outline'
    },
    {
      title: 'New Customer Card Payment',
      url: '/card-payment',
      icon: 'card-outline'
    },
    {
      title: 'Card Payment List',
      url: '/payment-list',
      icon: 'card-outline'
    }
  ];

  constructor(
    private platform: Platform,
    private loadingController: LoadingController,
    private router: Router,
    private navController: NavController,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.platform.backButton.subscribeWithPriority(9999, () => {
        document.addEventListener('backbutton', (event) => {
          event.preventDefault();
          event.stopPropagation();
        }, false);
      });
      setTimeout(() => {
      }, 2000);
    });
  }

  loadData() {
    const data = localStorage.getItem('token-google').toString();
    if (data !== undefined && data != null && data !== '') {
      this.menuItems = JSON.parse(localStorage.getItem('perms').toString());
    }
  }

  async salir() {
    const loading = await this.loadingController.create({
      message: 'Loading..',
      spinner: 'dots',
      cssClass: 'mensajeCarga'
    });
    await loading.present().then(async () => {
      localStorage.removeItem('token-google');
      localStorage.removeItem('user-email');
      localStorage.removeItem('user-image');
      localStorage.removeItem('perms');
      localStorage.removeItem('id-sistema');
      loading.dismiss();
      this.navController.navigateRoot(['/login']);
    });
  }

  cleanSelectedProject() {
    localStorage.removeItem('selectedProject');
    console.log('remove from it');
  }

}
